import moment, {Moment} from 'moment';

const genChartPlaceholderData = (period?: Date | string | number | Moment) => {
    const data = {};
    const date = period ? moment(period) : moment();
    const formattedDate = date.format('YYYY-MM');
    const daysInMonth = date.daysInMonth();
    for (let x = daysInMonth; x >= 1; x--) {
        const dateKey = `${formattedDate}-${String(x).padStart(2, '0')}`; // YYYY-MM-DD
        data[dateKey] = {
            date: dateKey,
            referrals: 0
        };
    }
    return data;
};

export default genChartPlaceholderData;
